import { Component, OnInit } from '@angular/core';
import { CoreApisService } from './core-apis.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CoreApiHeroComponent } from './core-api-hero/core-api-hero.component';
import { BankingOperationsComponent } from './banking-operations/banking-operations.component';
import { RobustCoreApisComponent } from './robust-core-apis/robust-core-apis.component';
import { TransactionalFxComponent } from './transactional-fx/transactional-fx.component';
import { PowerfulApisComponent } from './powerful-apis/powerful-apis.component';
import { CustomerOnboardingComponent } from './customer-onboarding/customer-onboarding.component';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { CommonFaqComponent } from 'src/app/shared/components/faq/faq-on.component';
import { CommonExploreGlobalPanelComponent } from 'src/app/shared/components/explore-global-panel/explore-more.component';
import { CommonDiscoverWhyComponent } from 'src/app/shared/components/discover-why/discover-why.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { CommonReadyToComponent } from 'src/app/shared/components/ready-to/ready-to.component';

@Component({
  selector: 'app-core-apis',
  templateUrl: './core-apis.component.html',
  styleUrls: ['./core-apis.component.scss'],
  imports: [
    CoreApiHeroComponent,
    BankingOperationsComponent,
    RobustCoreApisComponent,
    TransactionalFxComponent,
    PowerfulApisComponent,
    CustomerOnboardingComponent,
    CommonLatestNewsComponent,
    CommonFaqComponent,
    CommonExploreGlobalPanelComponent,
    CommonDiscoverWhyComponent,
    CommonCompaniesPanelComponent,
    CommonReadyToComponent,
  ],
})
export class CoreApisComponent implements OnInit {
  companiesData:any;
  discoverData:any;
  faqData:any;
  newsList:any;
  readyToData:any;
  exploreMore:any;
  constructor(
    private coreApiPageService: CoreApisService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }
  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.coreApiPageService.getCoreApiPageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo'][0].fields;
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Verto API';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.psHeroPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);
    let logos = data.psCustomerStatsContentPanel.fields?.components.map(
      (el:any) => el?.fields?.image?.fields?.file?.url
    );
    this.companiesData = logos;
    this.discoverData = data.psCustomerStories.fields;
    this.faqData = data.psFaqPanel.fields;
    this.newsList = data.psBlogPanel[0].fields;
    this.readyToData = data.psGetStartedPanel.fields;
    this.exploreMore = data.psOtherProductsPanel.fields;
    this.posthogService.capturePageViewEvent('core_api');
  }
}
